class Badge {

  #data = {}

  constructor(data={})
  {
    this.#data = data
  }

  /**
   * Property getters.
   */
  
  get color()
  {
    return this.#data.color
  }

  get icon()
  {
    return this.#data.icon
  }

  get id()
  {
    return this.#data.id
  }

  get name()
  {
    return this.#data.name
  }

  get outlined()
  {
    return this.#data.outlined == true
  }

  /**
   * Computed properties.
   */

  
  

  /**
   * Relationships.
   */
  
  

  /**
   * Methods.
   */
  
  

}

export default Badge